module.exports = __webpack_public_path__ + "static/img/04.575fcbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/thuer/04.jpg
// module id = 459
// module chunks = 1